import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select } from 'ui/components';

const Filter = ({ show, onClose, ContractTable, setCount }) => {
  const handleFilter = async (e) => {
    if (ContractTable?.State?.filter) {
      let x = [];
      Object.keys(ContractTable?.State?.filter).forEach((k) => {
        if (ContractTable?.State?.filter[k]) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Customer</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            params={{"type": "customer"}}
            initialValue={ContractTable.State?.filter?.customer_id}
            row={(d) => {
              return {
                value: d.id,
                label: d?.company_name
                  ? `${d.name} - ${d.company_name}`
                  : `${d.name}`,
              };
            }}
            onSelected={(c) => {
              ContractTable.filter('customer_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Layanan</div>
          <Select.Remote
            required
            placeholder=""
            initialValue={ContractTable?.State?.filter?.service_type_id}
            keys={ContractTable?.State?.filter?.service_type_id}
            params={{
              service_id: '61cc19d9f42b986ab50c659b',
              order_by: 'service_id',
            }}
            url="/tms/service/type"
            row={(d) => {
              return {
                value: d.id,
                label: `${d?.service?.name} - ${d.name}`,
              };
            }}
            onSelected={(c) => {
              ContractTable.filter('service_type_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Vendor</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            initialValue={ContractTable.State?.filter?.vendor_id}
            params={{"type": 'vendor'}}
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            onSelected={(c) => {
              ContractTable.filter('vendor_id', c?.id);
              handleFilter();
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>


          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Customer</div>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{"type": 'customer'}}
              initialValue={ContractTable.State?.filter?.customer_id}
              row={(d) => {
                return {
                  value: d.id,
                  label: d?.company_name
                    ? `${d.name} - ${d.company_name}`
                    : `${d.name}`,
                };
              }}
              onSelected={(c) => {
                ContractTable.filter('customer_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Layanan</div>
            <Select.Remote
              required
              placeholder=""
              initialValue={ContractTable?.State?.filter?.service_type_id}
              keys={ContractTable?.State?.filter?.service_type_id}
              params={{
                service_id: '61cc19d9f42b986ab50c659b',
                order_by: 'service_id',
              }}
              url="/tms/service/type"
              row={(d) => {
                return {
                  value: d.id,
                  label: `${d?.service?.name} - ${d.name}`,
                };
              }}
              onSelected={(c) => {
                ContractTable.filter('service_type_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Vendor</div>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{"type": "vendor"}}
              initialValue={ContractTable.State?.filter?.vendor_id}
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              onSelected={(c) => {
                ContractTable.filter('vendor_id', c?.id);
                handleFilter();
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
